import { createSlice } from "@reduxjs/toolkit";

import {
  fetchSessionMasters,
  fetchSessionMasterById,
  addSessionMaster,
  updateSessionMaster,
  deleteSessionMaster,
} from "./sessionMaster.thunk";

const initialState = {
  sessionMasters: [],
  totalPages: 1,
  currentPage: 1,
  total: 0,
  limit: 10,
  loading: false,
  error: null,
  selectedSessionMaster: null,
};

const sessionMasterSlice = createSlice({
  name: "sessionMaster",

  initialState,

  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },

    setSelectedSessionMaster: (state, action) => {
      state.selectedSessionMaster = action.payload;
    },

    clearSelectedSessionMaster: (state) => {
      state.selectedSessionMaster = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ============================================================
         FETCH SESSION MASTER LIST
      ============================================================ */

      .addCase(fetchSessionMasters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchSessionMasters.fulfilled, (state, action) => {
        state.loading = false;

        state.sessionMasters = action.payload.data;

        state.totalPages =
          action.payload.meta.total_pages;

        state.total =
          action.payload.meta.total;

        state.limit =
          action.payload.meta.limit || 10;
      })

      .addCase(fetchSessionMasters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ============================================================
         FETCH SINGLE SESSION MASTER
      ============================================================ */

      .addCase(fetchSessionMasterById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchSessionMasterById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedSessionMaster = action.payload;
      })

      .addCase(fetchSessionMasterById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ============================================================
         ADD SESSION MASTER
      ============================================================ */

      .addCase(addSessionMaster.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(addSessionMaster.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(addSessionMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ============================================================
         UPDATE SESSION MASTER
      ============================================================ */

      .addCase(updateSessionMaster.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(updateSessionMaster.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(updateSessionMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ============================================================
         DELETE SESSION MASTER
      ============================================================ */

      .addCase(deleteSessionMaster.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(deleteSessionMaster.fulfilled, (state, action) => {
        state.loading = false;

        state.sessionMasters =
          state.sessionMasters.filter(
            (session) =>
              session.id !== action.payload.id
          );
      })

      .addCase(deleteSessionMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setCurrentPage,
  setSelectedSessionMaster,
  clearSelectedSessionMaster,
} = sessionMasterSlice.actions;

export default sessionMasterSlice.reducer;